import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7707e64c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-search flex-col sync-product-search" }
const _hoisted_2 = {
  class: "setting flex-bwn",
  style: {"margin-bottom":"10px"}
}

import { t } from '@/plugins/i18n'
import { ref, toRaw, watch, computed } from 'vue'
import { cloneDeep } from 'lodash'
import { clearForm, setDefaultForm } from '@/util/common'
import { isJA } from '@/store'
import dblclick from '@/components/BatchSearch/index'


export default /*#__PURE__*/_defineComponent({
  props: ['form', 'states', 'prepCategoryList'],
  emits: ['update:form'],
  setup(__props, { emit: emits }) {

const props = __props



const defaultForm = {
  productName: '',
  amazonMskuList: ''
}

const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)

const _form = ref(getForm(props.form))

watch(() => props.form, (newValue) => {
  _form.value = getForm(newValue)
})

const submit = () => {
  emits('update:form', cloneDeep(toRaw(_form.value)))
}

const resetForm = () => {
  clearForm(_form.value)
  emits('update:form', cloneDeep(toRaw(_form.value)))
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      inline: true,
      model: _form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(t)('商品名称'),
          prop: "productName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.productName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.productName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('Amazon sku'),
          prop: "amazonMskuList"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.amazonMskuList,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_form.value.amazonMskuList) = $event)),
              onDblclick: _cache[2] || (_cache[2] = ($event: any) => {_form.value.amazonMskuList = ''; _unref(dblclick)('amazonMskuList')}),
              placeholder: _unref(t)('双击批量搜索'),
              style: {"width":"220px"}
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_unref(isJA)())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('预处理分类'),
                prop: "productName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _form.value.preCategory,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_form.value.preCategory) = $event)),
                    "popper-class": "default-select-option-color",
                    class: "sync-product-select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _unref(t)('全部'),
                        value: ""
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('未设置'),
                        value: "NULL"
                      }, null, 8, ["label"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.prepCategoryList, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: item.descJa,
                          value: item.value,
                          key: index
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('预处理方'),
                prop: "productName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _form.value.prepOwner,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_form.value.prepOwner) = $event)),
                    "popper-class": "default-select-option-color",
                    class: "sync-product-select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _unref(t)('全部'),
                        value: ""
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('未设置'),
                        value: "NONE"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('无需更改'),
                        value: "NONE_ONLY"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('由亚马逊处理'),
                        value: "AMAZON_ONLY"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('由卖家处理'),
                        value: "SELLER_ONLY"
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('贴标方'),
                prop: "productName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _form.value.labelOwner,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_form.value.labelOwner) = $event)),
                    "popper-class": "default-select-option-color",
                    class: "sync-product-select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _unref(t)('全部'),
                        value: ""
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('未设置'),
                        value: "NONE"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('无需更改'),
                        value: "NONE_ONLY"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('由亚马逊处理'),
                        value: "AMAZON_ONLY"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _unref(t)('由卖家处理'),
                        value: "SELLER_ONLY"
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "warning",
              onClick: submit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "text",
              onClick: resetForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})